class WidthContainerMargins {
  private widthContainer: HTMLElement | null = null;
  private marginReceivers: Array<HTMLElement> = [];
  private offsetMargin: number = 0;
  private resizeTimeout: number | null = null;


  constructor() {
    this.widthContainer = document.querySelector('.width-container');
    if (this.widthContainer) {
      this.marginReceivers = Array.from(document.querySelectorAll('.margin-receiver'));
      this.init();
    }
  }

  private applyMargins() {
    this.marginReceivers.forEach(receiver => {
      const marginSides = receiver.dataset.marginSides?.split(',') || [];
      if (marginSides.length > 0) {
        let marginStyleString = ``
        marginSides.forEach((side: string) => {
          side = side.trim();
          marginStyleString += `margin-${side}: ${this.offsetMargin}px; `;
        });
        (receiver.style as any) = marginStyleString;
      }
    });
  }

  private getOffsetMargin() {
    return this.widthContainer?.offsetLeft || 0;
  }

  private documentResizeHandler() {
    this.offsetMargin = this.getOffsetMargin();
    this.applyMargins();
  }

  private debouncedResizeHandler() {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = window.setTimeout(() => {
      this.documentResizeHandler();
      this.resizeTimeout = null;
    }, 150);
  }


  private init() {
    this.offsetMargin = this.getOffsetMargin();
    this.applyMargins();
    window.addEventListener('resize', () => {
      this.debouncedResizeHandler();
    });
  }
}

export default function widthContainerMargins() {
  return new WidthContainerMargins();
}